<template>
  <a-pagination
    :current="page"
    :total="total ? total : 0"
    :pageSize="size"
    :show-total="onShowTotal"
    @change="handleChangePagination"
    showSizeChanger
    @showSizeChange="handleChangePagination"
  />
</template>

<script>
export default {
  name: "Pagination",
  props: {
    page: {
      type: Number,
      default: 1,
    },
    size: {
      type: Number,
      default: 10,
    },
    total: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    onShowTotal(total, range) {
      return `${range[0]}-${range[1]} of ${total} items`;
    },
    handleChangePagination(page, size) {
      this.$emit("handleChangePagination", { page, size });
    },
  },
};
</script>
